import React from "react";
import Cropper from "cropperjs";
import { Box } from "reflexbox";
import styled from "styled-components";

const StyledImg = styled.img`
  display: block;
  max-width: 100%;
`;

const ImageCropper = ({ image = "" }) => {
  const cropper = new Cropper(image, {
    aspectRatio: 16 / 9,
    crop(event) {      
    },
  });

  return (
    <Box width={1}>
      <StyledImg src={image} />
      {cropper}
    </Box>
  );
};

export default ImageCropper;
